module.exports = __webpack_public_path__ + "img/oneOrange.899229e7.jpg";